/*
 * Coordinación del arranque: el splash se queda hasta que el home avisa que
 * ya tiene sus datos y las imágenes de la primera pantalla (o hasta un tope).
 *
 * La app se monta DETRÁS del splash desde el primer instante, así que todo eso
 * se carga mientras se ve el logo; al quitarse, la pantalla ya está armada.
 */

let avisar;
const homeListo = new Promise((resolve) => { avisar = resolve; });

// Lo llama el home cuando está listo para verse. Llamarlo de más no hace nada.
export const marcarHomeListo = () => avisar();

// Promesa que el splash espera.
export const esperarHomeListo = () => homeListo;

// Al revés: el home espera a que el splash se quite para animar su entrada
// (ya cargado detrás, aparece en cascada en vez de estar quieto de golpe).
let avisarSplash;
let splashFuera = false;
const splashTerminado = new Promise((resolve) => { avisarSplash = resolve; });

export const marcarSplashTerminado = () => { splashFuera = true; avisarSplash(); };
export const esperarSplashTerminado = () => splashTerminado;
export const yaSeFueElSplash = () => splashFuera;

// JSON (Lottie) compartido entre la precarga del arranque y los componentes
// que los pintan: se pide una sola vez, y lo ya descargado se puede leer en el
// primer render (jsonListo) para que no aparezca un cuadro después.
const promesasJson = new Map();
const jsonResuelto = new Map();

export const cargarJson = (url) => {
  if (!url) return Promise.resolve(null);
  if (!promesasJson.has(url)) {
    promesasJson.set(url, fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { jsonResuelto.set(url, d); return d; })
      .catch(() => null));
  }
  return promesasJson.get(url);
};

export const jsonListo = (url) => jsonResuelto.get(url) ?? null;

// Descarga y decodifica una imagen, para que al mostrarse aparezca entera y no
// a pedazos. Nunca falla: una imagen rota no debe trabar el arranque.
// Resuelve con la imagen (para leer su tamaño natural) o null si no hay.
// decode() tiene tope: Chrome lo resuelve hasta pintar un cuadro, y si la
// pestaña no está pintando (en segundo plano, o con el splash recién montado)
// se queda colgado y el splash esperaba hasta su tope de 5 s. La imagen ya
// está descargada al llegar onload; el decodificado previo es un extra.
const TOPE_DECODE_MS = 150;

export const precargarImagen = (url) => new Promise((resolve) => {
  if (!url) return resolve(null);
  const img = new Image();
  img.decoding = 'async';
  const listo = () => resolve(img);
  img.onload = () => {
    if (!img.decode) return listo();
    Promise.race([
      img.decode().catch(() => {}),
      new Promise((r) => setTimeout(r, TOPE_DECODE_MS)),
    ]).then(listo);
  };
  img.onerror = () => resolve(null);
  img.src = url;
});
